import React from 'react'

import Button from '@mui/material/Button'

const OpenButton = props => {
  const { joinUrl, disabled, children, variant, size, color } = props

  return (
    <Button
      disabled={disabled}
      href={joinUrl}
      target='_blank'
      variant={variant}
      size={size}
      color={color}
    >
      {children}
    </Button>
  )
}

export default OpenButton
